"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApSearchDropdown = void 0;
var React = require("react");
var Autosuggest = require("react-autosuggest");
var styles_1 = require("./styles");
var getSuggestionValue = function (suggestion) { return suggestion.name; };
var renderSuggestion = function (suggestion) { return React.createElement("div", null, suggestion.name); };
var ApSearchDropdown = /** @class */ (function (_super) {
    __extends(ApSearchDropdown, _super);
    function ApSearchDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focus: false,
            suggestions: _this.props.options,
            value: _this.props.value,
        };
        _this.justFocused = false;
        _this.onInputChange = function (event, _a) {
            var newValue = _a.newValue;
            _this.setState({
                value: newValue,
            });
            if (_this.props.onInputChange) {
                _this.props.onInputChange(newValue);
            }
        };
        _this.onInputFocus = function (event) {
            _this.justFocused = true;
            setTimeout(function () { return (_this.justFocused = false); }, 100);
            _this.setState({
                focus: true,
            });
            if (_this.props.onInputFocus) {
                _this.props.onInputFocus();
            }
            return event.target.select();
        };
        _this.onInputBlur = function (event) {
            _this.setState({
                focus: false,
            });
            if (_this.props.onInputBlur) {
                _this.props.onInputBlur(event);
            }
        };
        _this.onSuggestionsFetchRequested = function (_a) {
            var value = _a.value;
            _this.setState({
                suggestions: _this.getSuggestions(value),
            });
        };
        _this.getSuggestions = function (value) {
            if (value === void 0) { value = ''; }
            var _a = _this.props, options = _a.options, allowNewOption = _a.allowNewOption;
            var trimmedValue = value.trim();
            if (trimmedValue === '') {
                return options;
            }
            var regex = new RegExp('^' + trimmedValue, 'i');
            var suggestions = options.filter(function (option) { return regex.test(option.name); });
            var isExactMatch = !!options.find(function (option) { return option.name === trimmedValue; });
            var addNewOption = allowNewOption && !isExactMatch
                ? [{ name: trimmedValue, value: trimmedValue }]
                : [];
            if (_this.justFocused && suggestions.length < 2) {
                return __spread(addNewOption, options);
            }
            return __spread(addNewOption, suggestions);
        };
        _this.onSuggestionsClearRequested = function () {
            _this.setState({
                suggestions: [],
            });
        };
        _this.onSuggestionSelected = function (event, _a) {
            var suggestion = _a.suggestion;
            if (_this.props.onSuggestionSelected) {
                _this.props.onSuggestionSelected(suggestion.value);
            }
        };
        return _this;
    }
    ApSearchDropdown.prototype.componentDidUpdate = function (prevProps) {
        var value = this.props.value;
        if (value !== prevProps.value) {
            this.setState({ value: value });
        }
    };
    ApSearchDropdown.prototype.render = function () {
        var _a = this.props, placeholder = _a.placeholder, className = _a.className, disabled = _a.disabled, withArrow = _a.withArrow;
        var _b = this.state, focus = _b.focus, value = _b.value, suggestions = _b.suggestions;
        var inputProps = {
            onChange: this.onInputChange,
            onFocus: this.onInputFocus,
            onBlur: this.onInputBlur,
            disabled: disabled,
            placeholder: placeholder,
            value: value,
        };
        return (React.createElement(styles_1.Wrapper, { className: "ap-search-dropdown" + (className ? " " + className : '') },
            React.createElement(Autosuggest, { suggestions: suggestions, onSuggestionsFetchRequested: this.onSuggestionsFetchRequested, onSuggestionsClearRequested: this.onSuggestionsClearRequested, getSuggestionValue: getSuggestionValue, renderSuggestion: renderSuggestion, onSuggestionSelected: this.onSuggestionSelected, inputProps: inputProps, highlightFirstSuggestion: true, focusInputOnSuggestionClick: false, shouldRenderSuggestions: function () { return true; } }),
            withArrow && (React.createElement(styles_1.Arrow, { iconName: "baseline_arrow_drop_down", isFocus: focus }))));
    };
    ApSearchDropdown.defaultProps = {
        allowNewOption: false,
        placeholder: 'Select an option',
        value: '',
        withArrow: false,
    };
    return ApSearchDropdown;
}(React.Component));
exports.ApSearchDropdown = ApSearchDropdown;
//# sourceMappingURL=ApSearchDropdown.js.map